<template>
  <div class="container flex-ac">
    <div class="btn">
      <img
        src="@/assets/images/comp/播放.png"
        v-show="!play"
        @click="playClick(play)"
        alt=""
      />
      <img
        src="@/assets/images/comp/暂停.png"
        v-show="play"
        @click="playClick(play)"
        alt=""
      />
    </div>
    <div style="width: calc(100% - 40px); height: 40px">
      <div class="top flex-ac flex-sa">
        <template v-if="timeSelect == '实时'"
          ><div
            v-for="(it, i) in hours"
            :key="i"
            :title="it.dateTimes + ' ' + it.hour + '时'"
            @click="timeClick(it, i)"
          >
            <div
              :style="{
                background: timeInd >= i ? 'rgba(14,194,255,.3)' : '',
              }"
            ></div></div
        ></template>
        <template v-else>
          <div
            v-for="(it, i) in days"
            :key="i"
            :title="it.dateTimes"
            class="flex-c flex-ac"
            @click="timeClick(it, i)"
          >
            <div
              :style="{
                background: timeInd >= i ? 'rgba(14,194,255,.3)' : '',
              }"
            ></div>
          </div>
        </template>
      </div>
      <div class="bottom flex-ac flex-sa">
        <div
          v-for="(it, i) in days"
          :key="i"
          :title="it.dateTimes"
          class="flex-c flex-ac"
        >
          <span>{{ it.times }}</span>
          <!-- <span>{{ i }} - {{ timeInd }}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {
      hours: [],
      days: [],
      timeInd: 0,
      play: false,
      timeSelect: "实时",
      maxInd: 0,
    };
  },
  watch: {
    "$parent.$refs.dqComp.$refs.homeMap.timeLoadAniInd"(v) {
      if (this.timeInd == this.maxInd) {
        this.play = !this.play;
      }
      if (this.timeInd < this.maxInd) {
        this.timeInd += 1;
      }
    },
  },
  mounted() {
    this.initTimeLine(4);
    this.$bus.$on("timeSelect", (v) => {
      this.play = false;
      this.timeSelect = v;
      const refDom = this.$parent.$refs.homeMap;
      clearTimeout(refDom.timeLoadAni_timeout);
      let vTime = 0;
      switch (v) {
        case "实时":
          vTime = 4;
          break;
        case "日":
          vTime = 15;
          break;
        case "月":
          vTime = 12;
          break;
        case "年":
          vTime = 10;
          break;
      }
      this.initTimeLine(vTime);
    });
  },
  methods: {
    hoursAni() {
      this.play = !this.play;
      const refDom = this.$parent.$refs.homeMap;
      let selectTime = this.hours[this.timeInd];
      let maxInd = this.hours[this.maxInd];

      let sTime = selectTime.dateTimes;
      let eTime = maxInd.dateTimes;

      let timeArr = [];
      for (let i = 0; i < this.hours.length; i++) {
        if (i >= this.timeInd && i <= this.maxInd) {
          timeArr.push(this.hours[i].dateTimes);
        }
      }
      refDom.timeLoadAni(this.play, sTime, eTime, timeArr, 0);
    },
    daysAni() {
      this.play = !this.play;
      const refDom = this.$parent.$refs.homeMap;
      let selectTime = this.days[this.timeInd];
      let maxInd = this.days[this.maxInd];
      let sTime = selectTime.dateTimes;
      let eTime = maxInd.dateTimes;
      let timeArr = [];
      for (let i = 0; i < this.days.length; i++) {
        if (i >= this.timeInd && i <= this.maxInd) {
          if (this.timeSelect == "年") {
            timeArr.push(
              this.days[i].dateTimes + this.$formatDate(new Date(), "-MM-dd")
            );
          } else {
            timeArr.push(this.days[i].dateTimes);
          }
        }
      }
      setTimeout(() => {
        refDom.timeLoadAni(this.play, sTime, eTime, timeArr, 0);
      });
    },
    playClick() {
      if (this.play) {
        const refDom = this.$parent.$refs.homeMap;
        clearTimeout(refDom.timeLoadAni_timeout);
        this.play = !this.play;
      } else {
        if (this.timeInd == this.maxInd) {
          if (this.timeSelect == "实时") {
            this.timeInd = this.maxInd - 24;
          } else if (this.timeSelect == "日") {
            this.timeInd = this.maxInd - 5;
          } else if (this.timeSelect == "月") {
            this.timeInd = this.maxInd - 5;
          } else if (this.timeSelect == "年") {
            this.timeInd = this.maxInd - 8;
          }
        }
        if (this.timeSelect == "实时") {
          this.hoursAni();
        } else {
          this.daysAni();
        }
      }
    },
    initTimeLine(num) {
      this.days = [];
      this.hours = [];
      for (let i = num; i >= 0; i--) {
        if (this.timeSelect == "实时") {
          this.days.push({
            times: this.$formatDate(
              new Date(new Date() - i * 24 * 3600 * 1000),
              "MM-dd"
            ),
            dateTimes: this.$formatDate(
              new Date(new Date() - i * 24 * 3600 * 1000),
              "yyyy/MM/dd hh" + ":00"
            ),
          });
        } else if (this.timeSelect == "日") {
          this.days.push({
            times: this.$formatDate(
              new Date(new Date() - i * 24 * 3600 * 1000),
              "MM-dd"
            ),
            dateTimes: this.$formatDate(
              new Date(new Date() - i * 24 * 3600 * 1000),
              "yyyy/MM/dd"
            ),
          });
        } else if (this.timeSelect == "月") {
          this.days.push({
            times: this.$formatDate(
              new Date(new Date() - i * 24 * 30 * 3600 * 1000),
              "yyyy年MM月"
            ),
            dateTimes: this.$formatDate(
              new Date(new Date() - i * 24 * 30 * 3600 * 1000),
              "yyyy-MM"
            ),
          });
        } else if (this.timeSelect == "年") {
          this.days.push({
            times: this.$formatDate(
              new Date(new Date() - i * 24 * 365 * 3600 * 1000),
              "yyyy年"
            ),
            dateTimes: this.$formatDate(
              new Date(new Date() - i * 24 * 365 * 3600 * 1000),
              "yyyy"
            ),
          });
        }
      }

      for (let i in this.days) {
        for (let k = 0; k < 24; k++) {
          this.hours.push({
            times: `${this.days[i].times} ${k < 10 ? "" + 0 + k : k}时`,
            hour: k,
            dateTimes: `${this.days[i].dateTimes.slice(0, 10)} ${
              k < 10 ? "" + 0 + k : k
            }:00`,
          });
        }
      }
      if (this.timeSelect == "实时") {
        for (let i in this.hours) {
          if (
            this.hours[i].times ==
            this.$formatDate(
              new Date(new Date() - 1 * 3600 * 1000),
              "MM-dd hh"
            ) +
              "时"
          ) {
            this.timeInd = +i;
            this.maxInd = +i;
            break;
          }
        }
      } else if (this.timeSelect == "日") {
        for (let i in this.days) {
          if (
            this.days[i].times ==
            this.$formatDate(new Date(new Date()), "MM-dd")
          ) {
            this.timeInd = +i;
            this.maxInd = +i;
            break;
          }
        }
      } else if (this.timeSelect == "月") {
        for (let i in this.days) {
          if (
            this.days[i].times ==
            this.$formatDate(new Date(new Date()), "yyyy年MM月")
          ) {
            this.timeInd = +i;
            this.maxInd = +i;
            break;
          }
        }
      } else if (this.timeSelect == "年") {
        for (let i in this.days) {
          if (
            this.days[i].times ==
            this.$formatDate(new Date(new Date()), "yyyy年")
          ) {
            this.timeInd = +i;
            this.maxInd = +i;
            break;
          }
        }
      }
      this.timeClick("", +this.timeInd);
    },
    timeClick(it, i) {
      if (this.maxInd < i) {
        this.timeInd = this.maxInd;
      } else {
        this.timeInd = +i;
      }
      this.play = false;

      const refDom = this.$parent.$refs.homeMap;

      clearTimeout(refDom.timeLoadAni_timeout);

      let selectTime = "";
      if (this.timeSelect == "实时") {
        selectTime = this.hours[this.timeInd].dateTimes;
      } else {
        selectTime = this.days[this.timeInd].dateTimes;
      }
      this.$store.dispatch("map/setDateTime", selectTime);
      // refDom.loadMapData(selectTime);
    },
  },
  destroyed() {
    this.$bus.$off("timeSelect");
  },
};
</script>
<style lang="stylus" scoped>
.container {
  width: 98%;
  position: absolute;
  bottom: 5px;
  left: 1vw;
  color: #fff;
  z-index: 3;
}

.top {
  width: 100%;
  position: relative;
  border-bottom: rgba(255, 255, 255, 0.5) 1px solid;
  border-right: rgba(255, 255, 255, 0.5) 1px solid;
  box-sizing: border-box;
  height: 10px;

  div {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    div {
      height: 10px;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.5);
      border-left: rgba(255, 255, 255, 0.5) 1px solid;
      box-sizing: border-box;
    }

    span {
      line-height: 20px;
      display: block;
      text-align: center;
    }
  }
}

.bottom {
  width: 100%;
  border-bottom: rgba(255, 255, 255, 0.5) 1px solid;
  box-sizing: border-box;
  height: 30px;

  div {
    width: 25%;
    height: 100%;
    border-left: rgba(255, 255, 255, 0.5) 1px solid;
    box-sizing: border-box;

    &:last-child {
      border-right: rgba(255, 255, 255, 0.5) 1px solid;
    }
  }

  span {
    line-height: 20px;
  }
}

.btn {
  width: 40px;
  height: 100%;
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  height: 40px;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/timeLine.vue